import request from "@/utils/request";
import store from "@/store";
import {
  heightEditAndroid,
  floorHeightAndroid,
  axisListAndroid,
  axisEditAndroid,
  constructionStrengthDetailAndroid,
  constructionStrengthEditAndroid,
  sizeEditAndroid,
  sizeInfoAndroid,
  ConstructionDeleteAndroid,
  calibrationEditAndroid,
  calibrationInfoAndroid,
  depthTransformationAndroid,
  batchDetectionEditAndroid,
  calculationDetailsAndroid,
  batchEstimationAndroid,
  croingStrengthOutlierAndroid,
  croingStrengthCalculateOutlierAndroid,
  croingStrengthConfirmOutlierAndroid,
  croingStrengthExportAndroid,
  croingStrengthAndroid,
  croingStrengthEditAndroid,
  croingStrengthDeletedAndroid,
  projectDetailAndroid,
  BuildingCracksEditAndroid,
  BuildingDisplacementEditAndroid,
  BuildingCracksListAndroid,
  BuildingDisplacementListAndroid,
  newBatchListAndroid,
  newBatchEditAndroid,
  detectionAndroid,
  delFloorDetectionAndroid,
  DetectionStatusListAndroid,
  DetectionTableListAndroid,
  reportModelListAndroid,
  floorHeightDeleteAndroid,
  SpaceExampleAndroid,
  SpaceListAndroid,
  SpaceEditAndroid,
  GroundFoundationEditAndroid,
  GroundFoundationListAndroid,
  ShearingObliqueEditAndroid,
  SettlementDetectionListAndroid,
  SettlementDetectionEditAndroid,
  ShearingObliqueListAndroid,
  WeakCollapseListAndroid,
  WeakCollapseEditAndroid,
  OverallConnectionListAndroid,
  OverallConnectionEditAndroid,
  StructuralSystemInfoAndroid,
  StructuralSystemEditAndroid,
  ReliabilityListAndroid,
  ReliabilityEditAndroid,
  SuperFirmnessInfoAndroid,
  SuperFirmnessEditAndroid,
  MaintsysSafeInfoAndroid,
  MaintsysSafeEditAndroid,
  MaintsysUseInfoAndroid,
  MaintsysUseEditAndroid,
  reportListAndroid,
  componentInfoAndroid,
  detectionReportTableAndroid,
  androidgetReinforcementstretch,
  androidmodifycrackdisplacement,
  androidgetReportModelList,
  androidgetReinforcementstretchReport,
  androidupdreinforcementstretchReport,
  androidstrengthIdentification,
  androidgetStructuralSystem,
  androidupdateStructuralSystem,
  androidgetOverallConnection,
  androidupdateOverallConnection,
  androidgetpickstatus,
  androidgetpickstatusall,
  androidEditReportMoel,
  confirmDeleteAndroid,
  getBuildingCrackListByGuidAndroid,
} from "@/api/androidApi";

// 构建列表
export function constructioList(params) {
  return request({
    url: "/api/v1/cad/constructioList",
    method: "get",
    params,
  });
}
// 构建添加
export function constructioAdd(data) {
  return request({
    url: "/api/v1/cad/constructioAdd",
    method: "post",
    data,
  });
}
// 构建修改
export function constructioUpdate(data) {
  return request({
    url: "/api/v1/cad/constructioUpdate",
    method: "post",
    data,
  });
}

// 构建删除
export function constructioDeleted(data) {
  return request({
    url: "/api/v1/cad/constructioDeleted",
    method: "delete",
    data,
  });
}

// ------------------------- 检测 ----------------------
// 构件-检测数据查询是否已检查
export function detection(data) {
  if (store.state.app.isAndroid) {
    return detectionAndroid(data);
  }
  return request({
    url: "/api/v1/Construction/detection",
    method: "post",
    data,
  });
}

// 构件-检测联动删除
export function confirmDelete(data) {
  if (store.state.app.isAndroid) {
    return confirmDeleteAndroid(data);
  }
  return request({
    url: "/api/v1/Construction/confirmDelete",
    method: "delete",
    data,
  });
}

export function delFloorDetection(data) {
  if (store.state.app.isAndroid) {
    return delFloorDetectionAndroid(data);
  }
  return request({
    url: "/api/v1/Floor/confirmDelete",
    method: "delete",
    data,
  });
}

// 抽检比例列表
export function samplingRatioDetail(params) {
  return request({
    url: "/api/v1/samplingRatioDetail",
    method: "get",
    params,
  });
}
// 强度检测-批设定列表
export function batchList(params) {
  return request({
    url: "/api/v1/batchList",
    method: "get",
    params,
  });
}

// 删除批
export function batchDeleted(data) {
  return request({
    url: "/api/v1/batchDeleted",
    method: "delete",
    data,
  });
}

// 创建批
export function batchAdd(data) {
  return request({
    url: "/api/v1/batchAdd",
    method: "post",
    data,
  });
}
// 批名称编辑
export function batchNameEdit(data) {
  return request({
    url: "/api/v1/batchNameEdit",
    method: "post",
    data,
  });
}
// ---------- 检测-层高轴线
// 编辑层高
export function heightEdit(data) {
  if (store.state.app.isAndroid) {
    return heightEditAndroid(data);
  }
  return request({
    url: "/api/v1/heightEdit",
    method: "post",
    data,
  });
}
// 层高列表
export function floorHeight(params) {
  if (store.state.app.isAndroid) {
    return floorHeightAndroid(params);
  }
  return request({
    url: "/api/v1/floorHeight",
    method: "get",
    params,
  });
}
// 轴线列表
export function axisList(params) {
  if (store.state.app.isAndroid) {
    return axisListAndroid(params);
  }
  return request({
    url: "/api/v1/axisList",
    method: "get",
    params,
  });
}
// 轴线编辑
export function axisEdit(data) {
  if (store.state.app.isAndroid) {
    return axisEditAndroid(data);
  }
  return request({
    url: "/api/v1/axisEdit",
    method: "post",
    data,
  });
}
// ---------- 检测-率定
// 率定编辑
export function calibrationEdit(data) {
  if (store.state.app.isAndroid) {
    return calibrationEditAndroid(data);
  }
  return request({
    url: "/api/v1/calibrationEdit",
    method: "post",
    data,
  });
}
// 率定信息
export function calibrationInfo(params) {
  if (store.state.app.isAndroid) {
    return calibrationInfoAndroid(params);
  }
  return request({
    url: "/api/v1/calibrationInfo",
    method: "get",
    params,
  });
}
// 批碳化深度
export function depthTransformation(params) {
  if (store.state.app.isAndroid) {
    return depthTransformationAndroid(params);
  }
  return request({
    url: "/api/v1/depthTransformation",
    method: "get",
    params,
  });
}
// 构件检测碳化
export function batchDetectionEdit(data) {
  if (store.state.app.isAndroid) {
    return batchDetectionEditAndroid(data);
  }
  return request({
    url: "/api/v1/batchDetectionEdit",
    method: "post",
    data,
  });
}

// ---------- 检测-批推定
// 砂浆回弹/砂浆贯入/砂浆回弹/计算详情
export function calculationDetails(params) {
  if (store.state.app.isAndroid) {
    return calculationDetailsAndroid(params);
  }
  return request({
    url: "/api/v1/calculationDetails",
    method: "get",
    params,
  });
}
// 砂浆回弹/砂浆贯入/砂浆回弹/批推定
export function batchEstimation(params) {
  if (store.state.app.isAndroid) {
    return batchEstimationAndroid(params);
  }
  return request({
    url: "/api/v1/batchEstimation",
    method: "get",
    params,
  });
}

// ---------- 取芯抗压/离群值
// 取芯抗压/离群值/详情
export function croingStrengthOutlier(params) {
  if (store.state.app.isAndroid) {
    return croingStrengthOutlierAndroid(params);
  }
  return request({
    url: "/api/v1/croingStrengthOutlier",
    method: "get",
    params,
  });
}
// 取芯抗压/离群值/计算离群值
export function croingStrengthCalculateOutlier(data) {
  if (store.state.app.isAndroid) {
    return croingStrengthCalculateOutlierAndroid(data);
  }
  return request({
    url: "/api/v1/croingStrengthCalculateOutlier",
    method: "post",
    data,
  });
}
// 取芯抗压/离群值/确定离群值
export function croingStrengthConfirmOutlier(data) {
  if (store.state.app.isAndroid) {
    return croingStrengthConfirmOutlierAndroid(data);
  }
  return request({
    url: "/api/v1/croingStrengthConfirmOutlier",
    method: "post",
    data,
  });
}
// 取芯抗压/芯样强度/芯样强度导出
export function croingStrengthExport(params) {
  if (store.state.app.isAndroid) {
    return croingStrengthExportAndroid(params);
  }
  return request({
    url: "/api/v1/croingStrengthExport",
    method: "get",
    params,
  });
}
// 取芯抗压-芯样强度-强度检测详情
export function croingStrength(params) {
  if (store.state.app.isAndroid) {
    return croingStrengthAndroid(params);
  }
  return request({
    url: "/api/v1/croingStrength",
    method: "get",
    params,
  });
}
// 取芯抗压/芯样强度/芯样强度编辑
export function croingStrengthEdit(data) {
  if (store.state.app.isAndroid) {
    return croingStrengthEditAndroid(data);
  }
  return request({
    url: "/api/v1/croingStrengthEdit",
    method: "post",
    data,
  });
}
// 取芯抗压/芯样强度/芯样强度删除
export function croingStrengthDeleted(data) {
  if (store.state.app.isAndroid) {
    return croingStrengthDeletedAndroid(data);
  }
  return request({
    url: "/api/v1/croingStrengthDeleted",
    method: "delete",
    data,
  });
}
// ---------- 构件检测
// 构件检测/强度检测/强度检测详情（取芯）/强度检测详情（回弹）
export function constructionStrengthDetail(params) {
  if (store.state.app.isAndroid) {
    return constructionStrengthDetailAndroid(params);
  }
  return request({
    url: "/api/v1/constructionStrengthDetail",
    method: "get",
    params,
  });
}
// 构件检测/强度检测/强度检测编辑（取芯）/强度检测编辑（回弹）
export function constructionStrengthEdit(data) {
  if (store.state.app.isAndroid) {
    return constructionStrengthEditAndroid(data);
  }
  return request({
    url: "/api/v1/constructionStrengthEdit",
    method: "post",
    data,
  });
}
export function setresilience(data) {
  if (store.state.app.isAndroid) {
    return constructionStrengthEditAndroid(data);
  }
  return request({
    url: "/api/v1/oyc/pro/setresilience.html",
    method: "post",
    data,
  });
}
// 构件检测/尺寸检测/编辑
export function sizeEdit(data) {
  if (store.state.app.isAndroid) {
    return sizeEditAndroid(data);
  }
  return request({
    url: "/api/v1/sizeEdit",
    method: "post",
    data,
  });
}
// 构件检测/尺寸检测/详情
export function sizeInfo(params) {
  if (store.state.app.isAndroid) {
    return sizeInfoAndroid(params);
  }
  return request({
    url: "/api/v1/sizeInfo",
    method: "get",
    params,
  });
}
// 构件-检测删除
export function ConstructionDelete(data) {
  if (store.state.app.isAndroid) {
    return ConstructionDeleteAndroid(data);
  }
  return request({
    url: "/api/v1/Construction/delete",
    method: "delete",
    data,
  });
}

// 构件-检测删除
export function reinforcementstretchdel(data) {
  if (store.state.app.isAndroid) {
    return ConstructionDeleteAndroid(data);
  }
  return request({
    url: "/api/v1/oyc/pro/reinforcementstretchdel.html",
    method: "delete",
    data,
  });
}

// ---------- 体系构造
// 墙类型检查获取
export function wallCheckList(params) {
  return request({
    url: "/api/v1/StructuralSystem/wallCheckList",
    method: "get",
    params,
  });
}

// 墙类型检查新增/修改
export function wallCheckServe(data) {
  return request({
    url: "/api/v1/StructuralSystem/wallCheckEdit",
    method: "post",
    data,
  });
}

// 地坪开裂
export function FloorCrackingList(params) {
  return request({
    url: "/api/v1/FloorCracking/list",
    method: "get",
    params,
  });
}
// 地坪开裂编辑
export function FloorCrackingEdit(data) {
  return request({
    url: "/api/v1/FloorCracking/edit",
    method: "post",
    data,
  });
}
// 沉降检测--沉降--编辑
export function SettlementDetectionEdit(data) {
  if (store.state.app.isAndroid) {
    return SettlementDetectionEditAndroid(data);
  }
  return request({
    url: "/api/v1/SettlementDetection/edit",
    method: "post",
    data,
  });
}
// 沉降检测--沉降--详情
export function SettlementDetectionList(params) {
  if (store.state.app.isAndroid) {
    return SettlementDetectionListAndroid(params);
  }
  return request({
    url: "/api/v1/SettlementDetection/list",
    method: "get",
    params,
  });
}
// 沉降检测--倾斜--编辑
export function ShearingObliqueEdit(data) {
  if (store.state.app.isAndroid) {
    return ShearingObliqueEditAndroid(data);
  }
  return request({
    url: "/api/v1/ShearingOblique/edit",
    method: "post",
    data,
  });
}
// 沉降检测--倾斜--详情
// export function ShearingObliqueList(params) {
//   return request({
//     url: "/api/v1/ShearingOblique/list",
//     method: "get",
//     params,
//   });
// }
// 构件复核--连接及构造--详情
export function StructuralSafeList(params) {
  return request({
    url: "/api/v1/StructuralSafe/list",
    method: "get",
    params,
  });
}
// 构件复核--连接及构造--编辑
export function StructuralSafeEdit(data) {
  return request({
    url: "/api/v1/StructuralSafe/edit",
    method: "post",
    data,
  });
}
// 构建裂损--编辑
export function BuildingCracksEdit(data) {
  if (store.state.app.isAndroid) {
    return BuildingCracksEditAndroid(data);
  }
  return request({
    url: "/api/v1/BuildingCracks/edit",
    method: "post",
    data,
  });
}
// 构建裂损--列表
export function BuildingCracksList(params) {
  if (store.state.app.isAndroid) {
    return BuildingCracksListAndroid(params);
  }
  return request({
    url: "/api/v1/BuildingCracks/list",
    method: "get",
    params,
  });
}
// 构建裂损--获取单独构件的单独类型的值
export function getBuildingCrackListByGuid(params) {
  if (store.state.app.isAndroid) {
    return getBuildingCrackListByGuidAndroid(params);
  }
  return request({
    url: "/api/v1/BuildingCracks/getBuildingCrackListByGuid",
    method: "get",
    params,
  });
}
// 构建变移--编辑
export function BuildingDisplacementEdit(data) {
  if (store.state.app.isAndroid) {
    return BuildingDisplacementEditAndroid(data);
  }
  return request({
    url: "/api/v1/BuildingDisplacement/edit",
    method: "post",
    data,
  });
}
// 构建变移--列表
export function BuildingDisplacementList(params) {
  if (store.state.app.isAndroid) {
    return BuildingDisplacementListAndroid(params);
  }
  return request({
    url: "/api/v1/BuildingDisplacement/list",
    method: "get",
    params,
  });
}
// 构件复核状态--编辑
export function ComponentStatusEdit(data) {
  return request({
    url: "/api/v1/ComponentReview/Status/edit",
    method: "post",
    data,
  });
}
// 构件复核状态--详情
export function ComponentStatusList(params) {
  return request({
    url: "/api/v1/ComponentReview/Status/list",
    method: "get",
    params,
  });
}
// 场地基础--编辑
export function FoundationEdit(data) {
  return request({
    url: "/api/v1/Foundation/edit",
    method: "post",
    data,
  });
}
// 场地基础--详情
export function FoundationList(params) {
  return request({
    url: "/api/v1/Foundation/list",
    method: "get",
    params,
  });
}
// 结构体系--详情
// export function StructuralSystemInfo(params) {
//   return request({
//     url: "/api/v1/StructuralSystem/info",
//     method: "get",
//     params,
//   });
// }
// 结构体系--编辑
// export function StructuralSystemEdit(data) {
//   return request({
//     url: "/api/v1/StructuralSystem/edit",
//     method: "post",
//     data,
//   });
// }
// 整体连接--详情
export function OverallConnectionInfo(params) {
  return request({
    url: "/api/v1/OverallConnection/info",
    method: "get",
    params,
  });
}

// 整体连接--构造柱--详情
export function getConstructionColumnDetection(params) {
  return request({
    url: "/api/v1/OverallConnection/getConstructionColumnDetection",
    method: "get",
    params,
  });
}
// // 薄弱易塌--详情
export function WeakCollapseInfo(params) {
  return request({
    url: "/api/v1/WeakCollapse/info",
    method: "get",
    params,
  });
}
// // 薄弱易塌--编辑
// export function WeakCollapseEdit(data) {
//   return request({
//     url: "/api/v1/WeakCollapse/edit",
//     method: "post",
//     data,
//   });
// }
// 上部结构-牢固性--详情
export function SuperFirmnessInfo(params) {
  if (store.state.app.isAndroid) {
    return SuperFirmnessInfoAndroid(params);
  }
  return request({
    url: "/api/v1/Superstructure/Firmness/list",
    method: "get",
    params,
  });
}
// 上部结构-牢固性--编辑
export function SuperFirmnessEdit(data) {
  if (store.state.app.isAndroid) {
    return SuperFirmnessEditAndroid(data);
  }
  return request({
    url: "/api/v1/Superstructure/Firmness/edit",
    method: "post",
    data,
  });
}
// 围护系统-安全性--详情
export function MaintsysSafeInfo(params) {
  if (store.state.app.isAndroid) {
    return MaintsysSafeInfoAndroid(params);
  }
  return request({
    url: "/api/v1/Maintsys/Safe/list",
    method: "get",
    params,
  });
}
// 围护系统-安全性--编辑
export function MaintsysSafeEdit(data) {
  if (store.state.app.isAndroid) {
    return MaintsysSafeEditAndroid(data);
  }
  return request({
    url: "/api/v1/Maintsys/Safe/edit",
    method: "post",
    data,
  });
}
// 围护系统-安全性--详情
export function MaintsysUseInfo(params) {
  if (store.state.app.isAndroid) {
    return MaintsysUseInfoAndroid(params);
  }
  return request({
    url: "/api/v1/Maintsys/Use/list",
    method: "get",
    params,
  });
}
// 围护系统-安全性--编辑
export function MaintsysUseEdit(data) {
  if (store.state.app.isAndroid) {
    return MaintsysUseEditAndroid(data);
  }
  return request({
    url: "/api/v1/Maintsys/Use/edit",
    method: "post",
    data,
  });
}
// -------------------------鉴定----------------------
// 场地基础--编辑
export function SiteFoundationEdit(data) {
  return request({
    url: "/api/v1/SiteFoundation/edit",
    method: "post",
    data,
  });
}
// 场地基础--详情
export function SiteFoundationList(params) {
  return request({
    url: "/api/v1/SiteFoundation/list",
    method: "get",
    params,
  });
}
// 模型检查--详情
export function ModelCheckList(params) {
  return request({
    url: "/api/v1/ModelCheck/list",
    method: "get",
    params,
  });
}
export function ModelCheckAdd(data) {
  return request({
    url: "/api/v1/ModelCheck/add",
    method: "post",
    data,
  });
}

// 结构汇总-构件评级-安全性--详情
export function ComponentRatingSafeList(params) {
  return request({
    url: "/api/v1/ComponentRating/Load/list",
    method: "get",
    params,
  });
}

// 承载力评级详情
export function ComponentRatingList(params) {
  return request({
    url: "/api/v1/ComponentRating/Load/info",
    method: "get",
    params,
  });
}

// 承载力评级编辑
export function ComponentRatingEdit(data) {
  return request({
    url: "/api/v1/ComponentRating/Load/edit",
    method: "post",
    data,
  });
}

//  结构汇总-构件评级-使用性--详情
export function ComponentRatingUseList(params) {
  return request({
    url: "/api/v1/ComponentRating/Use/list",
    method: "get",
    params,
  });
}
// 安全性-地基基础--详情
export function AppraisalSafeList(params) {
  return request({
    url: "/api/v1/Appraisal/FoundationSafe/list",
    method: "get",
    params,
  });
}
// 安全性-地基基础--编辑
export function AppraisalSafeEdit(data) {
  return request({
    url: "/api/v1/Appraisal/FoundationSafe/edit",
    method: "post",
    data,
  });
}
// 安全性-上部承重结构--详情
export function SafeUpperStructureList(params) {
  return request({
    url: "/api/v1/Safe/UpperStructure/list",
    method: "get",
    params,
  });
}
// 安全性-上部承重结构--编辑
export function SafeUpperStructureEdit(data) {
  return request({
    url: "/api/v1/Safe/UpperStructure/edit",
    method: "post",
    data,
  });
}
// 安全性-上部承重结构-承载力评级-详情
export function SafeUpperStructureBearing(params) {
  return request({
    url: "/api/v1/Safe/UpperStructure/bearing",
    method: "get",
    params,
  });
}
// 安全性-围护系统--详情
export function AppraisalMaintSysList(params) {
  return request({
    url: "/api/v1/Appraisal/MaintSysSafe/list",
    method: "get",
    params,
  });
}
// 安全性-围护系统--编辑
export function AppraisalMaintSysEdit(data) {
  return request({
    url: "/api/v1/Appraisal/MaintSysSafe/edit",
    method: "post",
    data,
  });
}
// ////
// 使用性-上部结构--详情
export function UseUpperStructureList(params) {
  return request({
    url: "/api/v1/Use/UpperStructure/list",
    method: "get",
    params,
  });
}
// 使用性-上部结构--编辑
export function UseUpperStructureEdit(data) {
  return request({
    url: "/api/v1/Use/UpperStructure/edit",
    method: "post",
    data,
  });
}
// 使用性-上部承重结构-承载力评级-详情
export function UseUpperStructureUseing(params) {
  return request({
    url: "/api/v1/Use/UpperStructure/useing",
    method: "get",
    params,
  });
}
// 使用性-地基基础--详情
export function UseFoundationMaintList(params) {
  return request({
    url: "/api/v1/Use/FoundationMaint/list",
    method: "get",
    params,
  });
}
// 使用性-地基基础--编辑
export function UseFoundationMaintEdit(data) {
  return request({
    url: "/api/v1/Use/FoundationMaint/edit",
    method: "post",
    data,
  });
}
// ////
// 可靠性--详情
export function ReliabilityList(params) {
  if (store.state.app.isAndroid) {
    return ReliabilityListAndroid(params);
  }
  return request({
    url: "/api/v1/Appraisal/Reliability/list",
    method: "get",
    params,
  });
}
// 可靠性--编辑
export function ReliabilityEdit(data) {
  if (store.state.app.isAndroid) {
    return ReliabilityEditAndroid(data);
  }
  return request({
    url: "/api/v1/Appraisal/Reliability/edit",
    method: "post",
    data,
  });
}
// ----------------结构汇总--结构鉴定--------------
// 体系构造--详情
export function ArchitectureList(params) {
  return request({
    url: "/api/v1/StructuralSystem/Architecture/list",
    method: "get",
    params,
  });
}
// 体系构造--编辑
export function ArchitectureEdit(data) {
  return request({
    url: "/api/v1/StructuralSystem/Architecture/edit",
    method: "post",
    data,
  });
}
// -------------------------成果----------------------
// 生成表格--详情
export function DetectionTableList(params) {
  if (store.state.app.isAndroid) {
    return DetectionTableListAndroid(params);
  }
  return request({
    url: "/api/v1/DetectionTable/list",
    method: "get",
    params,
  });
}
// 裂损，变移删除
export function DetectionTableDel(data) {
  return request({
    url: "/api/v1/DetectionTable/del",
    method: "delete",
    data,
  });
}

// 报告--详情
export function ReportWordList(params) {
  return request({
    url: "/api/v1/Report/Word/list",
    method: "get",
    params,
  });
}

// 报告--导出
export function DetectionTableExport(params) {
  return request({
    url: "/api/v1/DetectionTable/export",
    method: "get",
    params,
  });
}

// 报告--导出
export function DetectionTableExportWallBick(params) {
  return request({
    url: "/api/v1/oyc/pro/export.html",
    method: "get",
    params,
  });
}
// 层高测量删除
export function floorHeightDelete(data) {
  if (store.state.app.isAndroid) {
    return floorHeightDeleteAndroid(data);
  }
  return request({
    url: "/api/v1/floorHeightDelete",
    method: "delete",
    data,
  });
}

// // 报告--上报
// export function reportModel(data) {
//   return request({
//     url: "/api/v1/reportModel",
//     method: "post",
//     data,
//   });
// }

// ------------------------- 2024年9月21日检测-新 ----------------------
//  地基基础--场地--示例
export function SpaceExample(params) {
  if (store.state.app.isAndroid) {
    return SpaceExampleAndroid(params);
  }
  return request({
    url: "/api/v1/Space/example",
    method: "get",
    params,
  });
}

// 地基基础--场地--详情
export function SpaceList(params) {
  if (store.state.app.isAndroid) {
    return SpaceListAndroid(params);
  }
  return request({
    url: "/api/v1/Space/list",
    method: "get",
    params,
  });
}
// 地基基础--场地--编辑
export function SpaceEdit(data) {
  if (store.state.app.isAndroid) {
    return SpaceEditAndroid(data);
  }
  return request({
    url: "/api/v1/Space/edit",
    method: "post",
    data,
  });
}
// 地基基础--地基基础--编辑
export function GroundFoundationEdit(data) {
  if (store.state.app.isAndroid) {
    return GroundFoundationEditAndroid(data);
  }
  return request({
    url: "/api/v1/GroundFoundation/edit",
    method: "post",
    data,
  });
}
// 地基基础--地基基础--详情
export function GroundFoundationList(params) {
  if (store.state.app.isAndroid) {
    return GroundFoundationListAndroid(params);
  }
  return request({
    url: "/api/v1/GroundFoundation/list",
    method: "get",
    params,
  });
}

// 地基基础--倾斜--详情
export function ShearingObliqueList(params) {
  if (store.state.app.isAndroid) {
    return ShearingObliqueListAndroid(params);
  }
  return request({
    url: "/api/v1/ShearingOblique/list",
    method: "get",
    params,
  });
}
// 抗震鉴定-薄弱易塌-详情
export function WeakCollapseList(params) {
  if (store.state.app.isAndroid) {
    return WeakCollapseListAndroid(params);
  }
  return request({
    url: "/api/v1/WeakCollapse/list",
    method: "get",
    params,
  });
}
// 抗震鉴定-薄弱易塌-编辑
export function WeakCollapseEdit(params) {
  if (store.state.app.isAndroid) {
    return WeakCollapseEditAndroid(params);
  }
  return request({
    url: "/api/v1/WeakCollapse/edit",
    method: "post",
    data: params,
  });
}
// 项目-项目详情
export function projectDetail(params) {
  if (store.state.app.isAndroid) {
    return projectDetailAndroid(params);
  }
  return request({
    url: "/api/v1/projectDetail",
    method: "get",
    params,
  });
}

//  抗震鉴定-整体连接-详情
export function OverallConnectionList(params) {
  if (store.state.app.isAndroid) {
    return OverallConnectionListAndroid(params);
  }
  return request({
    url: "/api/v1/OverallConnection/list",
    method: "get",
    params,
  });
}

// 抗震鉴定-整体连接-编辑
export function OverallConnectionEdit(data) {
  if (store.state.app.isAndroid) {
    return OverallConnectionEditAndroid(data);
  }
  return request({
    url: "/api/v1/OverallConnection/edit",
    method: "post",
    data,
  });
}

//  抗震鉴定-结构体系-详情
export function StructuralSystemInfo(params) {
  if (store.state.app.isAndroid) {
    return StructuralSystemInfoAndroid(params);
  }
  return request({
    url: "/api/v1/StructuralSystem/info",
    method: "get",
    params,
  });
}

// 抗震鉴定-结构体系-编辑
export function StructuralSystemEdit(data) {
  if (store.state.app.isAndroid) {
    return StructuralSystemEditAndroid(data);
  }
  return request({
    url: "/api/v1/StructuralSystem/edit",
    method: "post",
    data,
  });
}

// 检测-抽检比例-列表
export function newBatchList(params) {
  if (store.state.app.isAndroid) {
    return newBatchListAndroid(params);
  }
  return request({
    url: "/api/v1/batch/list",
    method: "get",
    params,
  });
}

// 检测-抽检比例-新增
export function newBatchEdit(data) {
  if (store.state.app.isAndroid) {
    return newBatchEditAndroid(data);
  }
  return request({
    url: "/api/v1/batch/edit",
    method: "post",
    data,
  });
}

// 鉴定-抽检比例-检测批复核-构件信息
export function componentInfo(params) {
  if (store.state.app.isAndroid) {
    return componentInfoAndroid(params);
  }
  return request({
    url: "/api/v1/componentInfo",
    method: "get",
    params,
  });
}

// 检测--状态数据
export function DetectionStatusList(params) {
  if (store.state.app.isAndroid) {
    return DetectionStatusListAndroid(params);
  }
  return request({
    url: "/api/v1/detectedStatus/list",
    method: "get",
    params,
  });
}

// 检测--状态数据
export function newDetectionStatusList(params) {
  if (store.state.app.isAndroid) {
    return DetectionStatusListAndroid(params);
  }
  return request({
    url: "/api/v1/new/detection/list",
    method: "get",
    params,
  });
}

// 检测-汇总上报
export function reportModel(data) {
  return request({
    url: "/api/v1/reportModel",
    method: "post",
    data,
  });
}

// 检测-汇总上报列表
export function reportList(params) {
  if (store.state.app.isAndroid) {
    return reportListAndroid(params);
  }
  return request({
    url: "/api/v1/reportList",
    method: "get",
    params,
  });
}

// 检测-汇总上报异常列表
export function reportModelList(params) {
  // 离线做屏蔽-----------------------------------------------------------------
  if (store.state.app.isAndroid) {
    return reportModelListAndroid(params);
  }
  return request({
    url: "/api/v1/reportModelList",
    method: "get",
    params,
  });
}

// 检测-解除锁定
export function ReportModelUnlock(data) {
  return request({
    url: "/api/v1/reportModelUnlock",
    method: "post",
    data,
  });
}

// 鉴定-检测批复核-构件裂损与变移评定-构件变移评定-详情
export function DetectionReportTableList(params) {
  if (store.state.app.isAndroid) {
    return detectionReportTableAndroid(params);
  }
  return request({
    url: "/api/v1/detectionReportTable/list",
    method: "get",
    params,
  });
}

// 鉴定-检测批复核-构件裂损与变移评定-构件变移评定-编辑
export function BuildingDisplacementReportEdit(data) {
  return request({
    url: "/api/v1/buildingDisplacement/reportEdit",
    method: "post",
    data,
  });
}

// 鉴定-检测批复核-构件裂损与变移评定-构件裂缝/损伤评定-编辑
export function BuildingCracksReportEdit(data) {
  return request({
    url: "/api/v1/buildingCracks/reportEdit",
    method: "post",
    data,
  });
}

// 鉴定-可靠性评级-安全性评级-围护系统承重部分-详情
export function MaintsysSafeReportList(params) {
  return request({
    url: "/api/v1/Maintsys/Safe/reportList",
    method: "get",
    params,
  });
}

// 鉴定-可靠性评级-安全性评级-围护系统承重部分-编辑
export function MaintsysSafeReportEdit(data) {
  return request({
    url: "/api/v1/Maintsys/Safe/reportEdit",
    method: "post",
    data,
  });
}

// 鉴定-可靠性评级-安全性评级-围护系统承重部分-详情
export function AppraisalReliabilityList(params) {
  return request({
    url: "/api/v1/Appraisal/Reliability/list",
    method: "get",
    params,
  });
}

// 鉴定-可靠性评级-安全性评级-围护系统承重部分-编辑
export function AppraisalReliabilityEdit(data) {
  return request({
    url: "/api/v1/Appraisal/Reliability/edit",
    method: "post",
    data,
  });
}

// 鉴定-检测复核-配筋评定-修改-主筋评定值计算-柱-梁
export function getColOrBeamReinforcement(data) {
  return request({
    url: "/api/v1/getColOrBeamReinforcement",
    method: "post",
    data,
  });
}

// 鉴定-检测复核-配筋评定-修改-箍筋评定值计算-柱-梁
export function getColOrBeamEncrypted(data) {
  return request({
    url: "/api/v1/getColOrBeamEncrypted",
    method: "post",
    data,
  });
}

// 鉴定-检测复核-配筋评定-修改-评定值计算-板-墙
export function getSlabOrWallRearArea(data) {
  return request({
    url: "/api/v1/getSlabOrWallRearArea",
    method: "post",
    data,
  });
}

// 鉴定-检测复核-配筋评定-分类保存
export function rebarReportEdit(data) {
  return request({
    url: "/api/v1/detectionReportTable/rebarReportEdit",
    method: "post",
    data,
  });
}

// 鉴定-结构验算-模型确认-构件强度赋值
export function ModelStrength(data) {
  return request({
    url: "/api/v1/ModelStrength/add",
    method: "post",
    data,
  });
}

// 鉴定-可靠性评级-安全性评级-上部承重结构-代表层安全性等级评定列表
export function SafeUpperStructureFlrList(params) {
  return request({
    url: "/api/v1/Safe/UpperStructure/flrList",
    method: "get",
    params,
  });
}

// 鉴定-可靠性评级-安全性评级-上部承重结构-其他列表
export function SafeUpperStructureRatingList(params) {
  return request({
    url: "/api/v1/Safe/UpperStructure/ratingList",
    method: "get",
    params,
  });
}

// 鉴定-可靠性评级-安全性评级-上部承重结构-编辑
export function SafeUpperStructureRatingEdit(data) {
  return request({
    url: "/api/v1/Safe/UpperStructure/ratingEdit",
    method: "post",
    data,
  });
}

// 鉴定-报告模板-列表
export function ReportTempList(params) {
  return request({
    url: "/api/v1/ReportTemp/list",
    method: "get",
    params,
  });
}

// 鉴定-报告模板-详情
export function ReportTempInfo(params) {
  return request({
    url: "/api/v1/ReportTemp/info",
    method: "get",
    params,
  });
}

// 鉴定-报告模板-详情
export function ReportAnnexList(params) {
  return request({
    url: "/api/v1/Report/annexList",
    method: "get",
    params,
  });
}
// 检测汇总 - 钢筋配置 - 砖
export function getReinforcementstretch(params) {
  if (store.state.app.isAndroid) {
    return androidgetReinforcementstretch(params);
  }
  return request({
    url: "/api/v1/oyc/pro/reinforcementstretch.html",
    method: "get",
    params,
  });
}
export function modifycrackdisplacement(params) {
  if (store.state.app.isAndroid) {
    return androidmodifycrackdisplacement(params);
  }
  return request({
    url: "/api/v1/oyc/pro/Modifycrackdisplacement",
    method: "post",
    params,
  });
}

// 获取是否可以点重新上报状态接口
export function getReportModelList(params) {
  if (store.state.app.isAndroid) {
    return androidgetReportModelList(params);
  }
  return request({
    url: "/api/v1/new/project/reportModelList",
    method: "get",
    params,
  });
}

// 获取墙拉结筋
export function getReinforcementstretchReport(params) {
  if (store.state.app.isAndroid) {
    return androidgetReinforcementstretchReport(params);
  }
  return request({
    url: "/api/v1/oyc/pro/reinforcementstretchReport",
    method: "get",
    params,
  });
}

// 修改墙拉结筋
export function updreinforcementstretchReport(data) {
  if (store.state.app.isAndroid) {
    return androidupdreinforcementstretchReport(data);
  }
  return request({
    url: "/api/v1/oyc/pro/updreinforcementstretchReport",
    method: "post",
    data,
  });
}

//砌体-获取抗震鉴定
export function strengthIdentification(params) {
  if (store.state.app.isAndroid) {
    return androidstrengthIdentification(params);
  }
  return request({
    url: "/api/v1/oyc/pro/strengthIdentification",
    method: "get",
    params,
  });
}

//砌体-获取结构体系
export function getStructuralSystem(params) {
  if (store.state.app.isAndroid) {
    return androidgetStructuralSystem(params);
  }
  return request({
    url: "/api/v1/StructuralSystem/info",
    method: "get",
    params,
  });
}

//砌体-修改结构体系
export function updateStructuralSystem(data) {
  if (store.state.app.isAndroid) {
    return androidupdateStructuralSystem(data);
  }
  return request({
    url: "/api/v1/StructuralSystem/edit",
    method: "post",
    data,
  });
}
//砌体-获取整体连接
export function getOverallConnection(params) {
  if (store.state.app.isAndroid) {
    return androidgetOverallConnection(params);
  }
  return request({
    url: "/api/v1/OverallConnection/brickworkelist",
    method: "get",
    params,
  });
}
//砌体-修改整体连接
export function updateOverallConnection(data) {
  if (store.state.app.isAndroid) {
    return androidupdateOverallConnection(data);
  }
  return request({
    url: "/api/v1/OverallConnection/brickworkedit",
    method: "post",
    data,
  });
}

//查询构件是否已经检查
export function getpickstatus(data) {
  if (store.state.app.isAndroid) {
    return androidgetpickstatus(data);
  }
  return request({
    url: "/api/v1/oyc/pro/getpickstatus",
    method: "post",
    data,
  });
}

//查询构件是否已经检查
export function getpickstatusall(data) {
  if (store.state.app.isAndroid) {
    return androidgetpickstatusall(data);
  }
  return request({
    url: "/api/v1/oyc/pro/getpickstatusall2",
    method: "post",
    data,
  });
}

// 编辑报告模板
export function editReportMoel(data) {
  if (store.state.app.isAndroid) {
    return androidEditReportMoel(data);
  }
  return request({
    url: "/api/v1/editReportMoel",
    method: "post",
    data,
  });
}

// 导入砼回弹
export function resilienceImport(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/resilienceImport",
    method: "post",
    data,
  });
}

// 导入楼层高度
export function floorImport(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/floorImport",
    method: "post",
    data,
  });
}

// 导入轴线尺寸
export function axisImport(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/axisImport",
    method: "post",
    data,
  });
}

// 截面尺寸导入
export function sectionImport(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/sectionImport",
    method: "post",
    data,
  });
}

// 砂浆贯入导入
export function shajianggrImport(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/shajianggrImport",
    method: "post",
    data,
  });
}

// 砂浆回弹导入
export function shajiangImport(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/shajiangImport",
    method: "post",
    data,
  });
}

// 砖回弹2导入
export function zhuanhttwoImport(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/zhuanhttwoImport",
    method: "post",
    data,
  });
}

// 砖回弹1导入
export function zhuanhtoneImport(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/zhuanhtoneImport",
    method: "post",
    data,
  });
}

// 导出构建编号
export function exportComponentNumber(data) {
  // if (store.state.app.isAndroid) {
  //   return androidEditReportMoel(data);
  // }
  return request({
    url: "/api/v1/oyc/pro/exportComponentNumber",
    method: "post",
    data,
  });
}

// 导出所有图片
export function exportProjectImags(params) {
  return request({
    url: "/api/v1/Report/getProjectImgs",
    method: "get",
    params,
  });
}

export function saveBuildingCrack(data) {
  return request({
    url: "/api/v1/BuildingCracks/saveBuildingCrack",
    method: "post",
    data,
  });
}

export function getAllBuildingCrackList(params) {
  return request({
    url: "/api/v1/BuildingCracks/getAllBuildingCrackList",
    method: "get",
    params,
  });
}
